var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCricket1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_71743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_323_71743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H0.5V24H24.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_323_71743)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_323_71743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0294 12.0001C16.0294 13.9494 14.4492 15.5295 12.5 15.5295C10.5508 15.5295 8.97059 13.9494 8.97059 12.0001C8.97059 10.0509 10.5508 8.4707 12.5 8.4707C14.4492 8.4707 16.0294 10.0509 16.0294 12.0001Z",
    fill: "#93E632"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1768 0.83947C17.6594 0.947204 17.8644 0.751323 11.7042 6.92156C5.24143 13.415 5.60264 13.0232 5.59288 13.6403C5.58312 14.3944 6.06149 14.982 6.80344 15.1387C7.32086 15.2367 7.34038 15.1974 5.9248 16.6274L4.65567 17.9007L5.96385 19.2033L7.26228 20.5157L8.43379 19.3404C9.64435 18.1259 9.71268 18.0769 9.90794 18.2238C9.94699 18.2532 10.0251 18.4002 10.0837 18.547C10.3473 19.2522 10.933 19.6636 11.6164 19.5951C12.1338 19.5461 12.2412 19.4579 13.8227 17.8713L15.2774 16.412L14.8575 16.0006C14.2132 15.3542 13.8227 14.6882 13.608 13.8166C13.4908 13.3464 13.5006 12.2299 13.6275 11.75C14.0277 10.2907 15.0626 9.1546 16.4586 8.6649C17.0151 8.46902 17.4642 8.40045 18.128 8.43963C19.3678 8.4886 20.471 9.04687 21.3008 10.0165L21.4571 10.1928L22.7457 8.89995C24.2491 7.42105 24.3272 7.31332 24.3272 6.6963C24.3272 6.02051 24.4152 6.12824 21.7792 3.47406C19.7388 1.41731 19.4069 1.10391 19.1628 0.986379C18.8601 0.829676 18.4795 0.780705 18.1768 0.83947Z",
    fill: "#93E632",
    fillOpacity: 0.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.347 9.28217C15.1212 9.68374 13.7934 11.9168 14.5159 14.0421C14.8088 14.8942 15.4921 15.6777 16.2927 16.0694C16.9077 16.3731 17.2006 16.4416 17.923 16.4416C18.6454 16.4416 18.9384 16.3731 19.5631 16.0597C19.9341 15.8735 20.0707 15.7757 20.4417 15.3936C20.8322 15.0019 20.9103 14.8942 21.1252 14.4633C21.4082 13.8854 21.496 13.5034 21.496 12.8374C21.496 11.2018 20.4417 9.81106 18.8504 9.37033C18.4599 9.26259 17.6985 9.22342 17.347 9.28217Z",
    fill: "#FC7700"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_323_71743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 8,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.347 9.28217C15.1212 9.68374 13.7934 11.9168 14.5159 14.0421C14.8088 14.8942 15.4921 15.6777 16.2927 16.0694C16.9077 16.3731 17.2006 16.4416 17.923 16.4416C18.6454 16.4416 18.9384 16.3731 19.5631 16.0597C19.9341 15.8735 20.0707 15.7757 20.4417 15.3936C20.8322 15.0019 20.9103 14.8942 21.1252 14.4633C21.4082 13.8854 21.496 13.5034 21.496 12.8374C21.496 11.2018 20.4417 9.81106 18.8504 9.37033C18.4599 9.26259 17.6985 9.22342 17.347 9.28217Z",
    fill: "#FC7700"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_323_71743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1239 10.3062C21.4746 9.81928 20.5856 9.70764 19.6521 9.99582C18.7188 10.284 17.8176 10.9484 17.1468 11.8428C16.4761 12.7372 16.0907 13.7884 16.0754 14.7651C16.0602 15.7419 16.4164 16.5641 17.0656 17.051L17.4996 16.4724C16.9617 16.069 16.6667 15.3878 16.6792 14.5788C16.692 13.7696 17.0112 12.8988 17.5668 12.1578C18.1225 11.4169 18.869 10.8665 19.6423 10.6278C20.4155 10.3891 21.152 10.4815 21.6899 10.8849L22.1239 10.3062Z",
    fill: "#834107"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84529 18.7136L3.64029 18.9193L4.94847 20.2317L6.24688 21.5441L6.46165 21.3188L6.6862 21.1033L5.38778 19.8007C4.67511 19.0858 4.08935 18.498 4.06983 18.498C4.06007 18.5079 3.95268 18.596 3.84529 18.7136Z",
    fill: "#FC7700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2443 20.3199C1.33638 21.2405 1.28757 21.3189 1.28757 21.7987C1.28757 22.2199 1.41448 22.4353 2.02952 23.0621C2.73242 23.7869 2.86911 23.8555 3.37675 23.8555C3.90393 23.8555 4.00156 23.7869 4.93877 22.8467L5.69048 22.0925L4.3823 20.7802L3.07411 19.4678L2.2443 20.3199Z",
    fill: "#FC7700"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_323_71743",
    x: 4.97059,
    y: 4.4707,
    width: 15.0588,
    height: 15.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_323_71743"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_71743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket1);
export default __webpack_public_path__ + "static/media/cricket 1.7e484d94b5022470152f4f4e427093bb.svg";
export { ForwardRef as ReactComponent };